export default {
  label: 'Souhlas s cookies',
  body: 'Používáme nezbytné soubory cookie, aby web fungoval správně. S vaším souhlasem bychom také využili analytické nástroje pro jeho zlepšení.',
  policy: 'Zásady používání souborů cookie',
  customize: 'Přizpůsobit',
  essentialOnly: 'Pouze nezbytné',
  acceptAll: 'Přijmout vše',
};
